// ═══════════════════════════════════════════════
// MASTER FRAUD TYPE LIST — used everywhere
// ReportFraud form, Dashboard search, My Reports filter, Admin filters
// ═══════════════════════════════════════════════

const FRAUD_TYPES = [
  "Car Damage",
  "Document Fraud",
  "Identity Theft",
  "Payment Fraud",
  "Fuel Theft",
  "Multiple Booking Fraud",
  "Non-Payment",
  "Accident Fraud",
  "Drunk and Drive",
  "Drugs Issue",
  "Mortgage the Car",
  "Selling the Car",
  "Other",
];

export default FRAUD_TYPES;
